import { ProviderApi } from "@/api/ProviderApi";
import { SELECT_INPUT_TYPE, VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";
import { LAST_YEARS, MONTHS, REPORT_FORMATS, REPORT_PRINT_FORMAT, } from "@utils/Constants";

const BuyReportFormConfig = {
    sections: [
        {
            "fields": [
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "providerId",
                        "label": "Proveedor",
                        "isHorizontal": true,
                        "optionsFunction": async () => {
                            const providers = await ProviderApi.optionsList();
                            return {
                                "-2": "Todos los Provedores",
                                ...providers
                            }
                        },
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 9
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "month",
                        "label": "Mes",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": MONTHS,
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "year",
                        "label": "Año",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": LAST_YEARS,
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    },
                ],
                [
                    {
                        "type": SELECT_INPUT_TYPE,
                        "name": "format",
                        "label": "Formato",
                        "isHorizontal": true,
                        "labelSizing": {
                            "sm": 2
                        },
                        "sizing": {
                            "sm": 4
                        },
                        "options": REPORT_FORMATS,
                        "defaultValue": REPORT_PRINT_FORMAT,
                    },
                ]
            ]
        }
    ],
};


export default BuyReportFormConfig;